import { render } from "./formvertical.vue?vue&type=template&id=d9287a34"
import script from "./formvertical.vue?vue&type=script&lang=js"
export * from "./formvertical.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__